import { generateDataModule, invalidateOnEventChange } from 'admin/modules/generateModule'
import { serviceGetCountDevicesOnsite } from 'admin/services/bluetrace'


const CountDevicesOnsiteModule = generateDataModule({
  initialData: 0,
  moduleKey: 'cpo/bluetrace/dashboard/countDevicesOnsite',
  reducerKey: 'admin.bluetrace.dashboard.countDevicesOnsite',
  refreshTime: 10000,
  services: {
    get: { service: serviceGetCountDevicesOnsite },
  },
})

invalidateOnEventChange(CountDevicesOnsiteModule)


// //////////////////////////////////////////////////////////////////////////////////////
// Selectors
// //////////////////////////////////////////////////////////////////////////////////////


// //////////////////////////////////////////////////////////////////////////////////////
// Actions
// //////////////////////////////////////////////////////////////////////////////////////


// //////////////////////////////////////////////////////////////////////////////////////
// Reducers
// //////////////////////////////////////////////////////////////////////////////////////


export default CountDevicesOnsiteModule
